module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__voice02-acc5ad6462a5740424fb1547dbe16341.png";